import 'react-dates/initialize'
import * as ReactDatesConstants from 'react-dates/lib/constants'
import * as ReactDates from 'react-dates'
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet'
import aphroditeInterface from 'react-with-styles-interface-aphrodite'
import VsTheme from '../listings/show/calendar_theme'

// ThemedStyleSheet.registerInterface(aphroditeInterface)
// ThemedStyleSheet.registerTheme(VsTheme)

window.aphroditeInterface = aphroditeInterface
window.VsTheme = VsTheme
window.ThemedStyleSheet = ThemedStyleSheet

window.ReactDates = ReactDates
window.ReactDatesConstants = ReactDatesConstants
